import { Injectable, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../../environments/environment';

export interface CadastroGestorRequest {
  cnpj: string;
  cpf: string;
}

export interface CadastroGestorResponse {
  usuarioId: number;
  nome: string;
  cpf: string;
  coMunicipioIbge: string;
}

@Injectable({
  providedIn: 'root',
})
export class GestorMunicipalService {
  private readonly url = `${environment.fullApiUrl}/cadastro-gestor`;
  private http = inject(HttpClient);

  cadastrar(request: CadastroGestorRequest): Observable<CadastroGestorResponse> {
    return this.http.post<CadastroGestorResponse>(this.url, request);
  }
}
